module.exports = __webpack_public_path__ + "img/send_solid_white.a7f99747.svg";